export default [
    {
        "product_type_id": "producttype-0adbb8e2-8f66-4bd2-904f-7f2faa31245d",
        "product_type_name_en": "Flower"
    },
    {
      "product_type_id": "producttype-194ff923-95ce-4b67-a5d6-fdd814c1da00",
      "product_type_name_en": "Concentrates"
    },
    {
      "product_type_id": "producttype-304zcs33-95ce-4e67-axd6-fdd867c1da00",
      "product_type_name_en": "Vape Pen Cartridge"
    },
    {
      "product_type_id": "producttype-f83ae5b5-0c4e-42ee-8a82-d263d9a23ac7",
      "product_type_name_en": "Edibles"
    },
    {
      "product_type_id": "producttype-a9da9052-c217-4a7c-aea1-0b984599fabc",
      "product_type_name_en": "Topicals"
    }
  ]